import { useRoleIdentifier } from "@/_shared/mixins";

const checkToken = (to, from, next) => {
  const foundToken = localStorage.getItem("token");
  foundToken ? next() : next({ path: "/login" });
};

const checkUserPermissions = (to, from, next) => {
  const isVip = useRoleIdentifier.methods.checkVipRole();
  isVip ? next() : next({ path: "/" });
};

export const routerMiddleware = {
  checkToken,
  checkUserPermissions,
};



// WEBPACK FOOTER //
// ./src/_shared/middlewares/routerMiddleware.js